<template>
  <div class="user_editPhone">
    <HeaderComponents></HeaderComponents>
    <div class="content">
      <div class="card">
        <div class="title">修改手机号</div>
        <div class="step">
          <Steps :current="step - 1">
            <Step title="验证码身份"></Step>
            <Step title="设置手机号"></Step>
            <Step title="完成修改"></Step>
          </Steps>
        </div>
        <Form class="form" :label-width="80" label-position="left">
          <FormItem label="原手机号:" v-if="step === 1">
            <Input class="input" v-model="loginForm.phone" disabled></Input>
          </FormItem>
          <FormItem label="验证码:" v-if="step === 1">
            <Input class="input"  number :maxlength="6" placeholder="请输入验证码" v-model="loginForm.code" style="width: 188px"></Input>
            <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCode()" :disabled="!show">
              <span v-if="show">获取验证码</span>
              <span v-if="!show">{{count}} s</span>
            </Button>
          </FormItem>
          <FormItem label="新手机号:" v-if="step === 2">
            <Input class="input" placeholder="请输新手机号" number :maxlength="11" v-model="loginForm.new_phone"></Input>
          </FormItem>
          <FormItem label="验证码:" v-if="step === 2">
            <Input class="input" placeholder="请输入验证码"  number :maxlength="6" v-model="loginForm.new_code" style="width: 188px"></Input>
            <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCodeNew()" :disabled="!showNew">
              <span v-if="showNew">获取验证码</span>
              <span v-if="!showNew">{{countNew}} s</span>
            </Button>
          </FormItem>
          <div class="success" v-if="step === 3">
            <div class="success-icon">
              <img src="../../assets/images/ok.png" alt>
            </div>
            <span>修改成功</span>
          </div>
          <div class="footer">
            <Button type="primary" v-if="step === 1" @click="nextStep">下一步</Button>
            <Button v-if="step === 2" @click="$router.go(-1)" style="margin-right: 20px">返回</Button>
            <Button type="primary" v-if="step === 2" @click="submit">确认修改</Button>
            <Button v-if="step === 3" @click="$router.go(-1)" style="margin-right: 20px">返回</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../components/header'

export default {
  name: 'user_security',
  components: {
    HeaderComponents
  },
  data () {
    return {
      step: 1,
      loginForm: {
        phone: '',
        code: '',
        new_code: '',
        new_phone: ''
      },
      show: true,
      count: 60,
      timer: null,
      showNew: true,
      countNew: 60,
      timerNew: null
    }
  },
  created () {
    let vm = this
    this.$request('6173cb9f48207', {
    }).then(res => {
      console.log(res)
      vm.loginForm.phone = res.data.data.user.phone
    })
  },
  methods: {
    nextStep () {
      let vm = this
      if (this.loginForm.code == '') {
        return this.$message.error('请输入验证码')
      }
      this.$request('62171430dc5e8', {
        code: this.loginForm.code + '',
        phone: this.loginForm.phone + ''
      }).then(res => {
        vm.step = 2
      })
    },
    submit () {
      let vm = this
      if (this.loginForm.new_phone == '') {
        return this.$message.error('请输入新手机号')
      }
      if (this.loginForm.new_code == '') {
        return this.$message.error('请输入验证码')
      }
      this.$request('62171450576e1', {
        code: this.loginForm.code + '',
        phone: this.loginForm.phone + '',
        new_code: this.loginForm.new_code + '',
        new_phone: this.loginForm.new_phone + ''

      }).then(res => {
        vm.step = 3
      })
    },
    getCode () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }

      if (!this.timer) {
        this.$request('610796cfa73ad', {
          phone: this.loginForm.phone + '',
          type: 'edit_phone'
        }).then(res => {
          this.show = false
          this.count = 60
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        })
      } else {
        return this.$message.error('请求验证码频繁')
      }
    },
    getCodeNew () {
      if (this.loginForm.new_phone == '') {
        return this.$message.error('请输入手机号')
      }

      if (!this.timerNew) {
        this.$request('610796cfa73ad', {
          phone: this.loginForm.new_phone + '',
          type: 'edit_phone'
        }).then(res => {
          this.showNew = false
          this.countNew = 60
          this.timerNew = setInterval(() => {
            if (this.countNew > 0 && this.countNew <= 60) {
              this.countNew--
            } else {
              this.showNew = true
              clearInterval(this.timerNew)
              this.timerNew = null
            }
          }, 1000)
        })
      } else {
        return this.$message.error('请求验证码频繁')
      }
    }
  }
}
</script>

<style lang="less">
.user_editPhone {

  .ivu-steps-title {
    margin-top: 2px;
  }

  .content {
    min-width: 1200px;
    padding: 0 100px;
    background-color: #f7f8fa;
    margin-top: 84px;
  }

  .card {
    background-color: #FFFFFF;
    padding: 20px;
    border-radius: 3px;

    .title {
      font-size: 18px;
      color: #333;
      font-weight: 450;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 70px;
        height: 3px;
        background-color: #FB9E2F;
      }
    }

    .step {
      width: 500px;
      margin-top: 60px;
    }

    .form {
      margin-top: 60px;

      .input {
        width: 300px;
      }

      .footer {
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }

    .success {
      width: 500px;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        margin-top: 10px;
      }
    }

    .success-icon {
      width: 80px;
      height: 80px;
      background-color: #2CCC6C;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
    }
  }
}

</style>
